// users/shared/address_inputs.html.hamlとあわせて使用
// 郵便番号から住所を自動入力。日本以外なら自動入力ボタンを隠す

document.addEventListener('turbolinks:load', () => {
  const button = document.getElementById('js-auto-fill-address-button')
  const postalCodeInput = document.getElementById(
    'user_address_postal_code'
  ) as HTMLInputElement
  const countryInput = document.getElementById(
    'user_address_country'
  ) as HTMLInputElement
  const regionSelect = document.getElementById(
    'user_address_region_select'
  ) as HTMLInputElement
  const localityInput = document.getElementById(
    'user_address_locality'
  ) as HTMLInputElement
  const streetAddressInput = document.getElementById(
    'user_address_street_address'
  ) as HTMLInputElement

  if (
    !button ||
    !postalCodeInput ||
    !countryInput ||
    !regionSelect ||
    !localityInput ||
    !streetAddressInput
  )
    return

  button.addEventListener('click', (e) => {
    e.preventDefault()

    const postalCode = postalCodeInput.value
    if (!/\d{7}/.exec(postalCode)) {
      alert('郵便番号を正しく入力してください')
      return
    }

    void (async () => {
      try {
        const url = `https://jp-postal-code-api.ttskch.com/api/v1/${postalCode}.json`
        const response = await fetch(url)
        if (response.status === 404) {
          alert('この郵便番号の住所が見つかりませんでした')
          return
        }
        const body = (await response.json()) as {
          addresses: {
            ja: {
              prefecture: string
              address1: string
              address2: string
              address3: string
              address4: string
            }
          }[]
        }
        const address = body.addresses?.[0]?.ja
        if (!address) {
          alert('この郵便番号の住所が見つかりませんでした')
          return
        }

        regionSelect.value = address.prefecture
        localityInput.value = address.address1
        streetAddressInput.value = `${address.address2}${address.address3}${address.address4}`
      } catch {
        alert('郵便番号データの取得に失敗しました')
      }
    })()
  })

  countryInput.addEventListener('change', () => {
    button.style.display = countryInput.value === 'JP' ? 'block' : 'none'
  })
})
